import { useEffect, useState } from 'react';

const useKeypress = (targetKey: string) => {
  const [keyPressed, setKeyPressed] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const keyupListener = (e: KeyboardEvent) => {
      const { key } = e;

      if (key === targetKey) {
        setKeyPressed(true);
      }
    };

    const keydownListener = (e: KeyboardEvent) => {
      const { key } = e;

      if (key === targetKey) {
        setKeyPressed(false);
      }
    };

    window.addEventListener('keydown', keyupListener);
    window.addEventListener('keyup', keydownListener);

    return () => {
      window.removeEventListener('keydown', keyupListener);
      window.removeEventListener('keyup', keydownListener);
    };
  }, [keyPressed]);

  return keyPressed;
};

export default useKeypress;
